import {FeaturesEnum} from './featuresFlagEnum';
import {ProductEnum} from './productEnum';

export const EXAMS_FEATURE_BY_HOST = {
	[ProductEnum.HAP]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_HAP,
	[ProductEnum.CCG]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_CCG,
	[ProductEnum.CLINIPAM]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_CLINIPAM,
	[ProductEnum.GNDI_MINAS]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_NDIMINAS,
	[ProductEnum.GNDI]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_NDISP,
	[ProductEnum.NOTREDAME_SAUDE]: FeaturesEnum.PORTAL_FEATURE_LAUDOEXAMES_NDISP,
};
